import React from 'react';

const AppFooter = () => {
  return '';
};

export default AppFooter;
